import {createContext, useState } from "react";
import getDecodedToken from "services/getDecodedToken";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) return {};
      const decoded = getDecodedToken(); 
      return {
        user: { username: decoded.username },
        roles: decoded.authorities,
        accessToken: token,
        tenantId: decoded?.tenantId ?? null,
      };
    } catch {
      return {};
    }
  });

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContext;